<template>
  <div>
    <div class="boxShell">
      <i class="iconfont icon-chenggong-icon topicon"></i>
      <p class="tip">提交成功</p>
      <Button
        :text="draw"
        :type="danger"
        class="nextStep"
        :click='goToNextPage'
      ></Button>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import Button from '@/components/Button.vue';
import ServerBank from '@/components/ServerBank.vue';

import { checkStatus } from './mixin';

export default {
  name: 'applicationCompleted',
  data() {
    return {
      danger: 'danger',
      draw: '查看我的融资',
    };
  },
  mixins: [checkStatus],
  components: {
    Button,
    ServerBank
  },
  methods: {
    goToNextPage() {
      window.location.href = '/backloansuper/loan/supermarket/login2Url/v1.0?k=myLoad';
    },
  },
};
</script>
<style scoped>
.boxShell {
  padding-top: 103px;
}
.topicon {
  margin-top: 103px;
  color: #ff6538;
  font-size: 60px;
}
.tip {
  color: #1c2438;
  font-size: 17px;
  text-align: center;
}
.nextStep {
  margin-top: 100px;
  margin-bottom: 7px;
}
</style>
